var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 offset-md-4 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-fill",
              attrs: { type: "submit" },
              on: { click: _vm.editTestimonial }
            },
            [_vm._v("Edit Testimonial")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.testimonial
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table table-bordered table-light" }, [
              _c("tr", [
                _c("th", [_vm._v("Id")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.testimonial.pkCarouselId))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Page ")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.testimonial.pageName))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Author")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.testimonial.author))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Designation")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.testimonial.designation))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Location")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.testimonial.location))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Quote")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.testimonial.quote))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Status")]),
                _vm._v(" "),
                _vm.testimonial.isActive == "0"
                  ? _c("td", [_vm._v("Inactive")])
                  : _c("td", [_vm._v("Active")])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Testimonial Details")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59c2ee3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c2ee3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Testimonials/TestimonialDetails.vue
// module id = 3M79
// module chunks = 0